import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentPage: "",
    isMovePage: false,
    isLayerView: false,
    documentSize: {
      width: 0,
      height: 0,
    },
      pageArrow:'next'
  },
  mutations: {
    changePage(state, pageName) {
      state.currentPage = pageName;
    },
    isMovePage(state, payload) {
      state.isMovePage = payload;
    },
    isLayerView(state, payload) {
      state.isLayerView = payload;
      window.nowPlayingVideo = false;
    },
    documentSetSize(state, payload) {
      state.documentSize = payload;
    },
      isPageArrow(state, payload){
      state.pageArrow = payload;
      }
  },
  getters: {
    activeLayer(state) {
      return state.isLayerView;
    },
    documentSize(state) {
      return state.documentSize;
    },
      pageArrow(state){
      return state.pageArrow;
      }
  },
  actions: {},
});
